import { Editor, Range, Transforms } from 'slate'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { CHARACTERS } from '../test/mention-data'
import { ReactEditor } from 'slate-react'
import { Portal } from '../index'

export const withMentions = (editor) => {
  const { isInline, isVoid } = editor

  editor.isInline = (element) => {
    return element.type === 'mention' ? true : isInline(element)
  }

  editor.isVoid = (element) => {
    return element.type === 'mention' ? true : isVoid(element)
  }

  return editor
}

export const insertMention = (editor, character) => {
  const mention = {
    type: 'mention',
    character,
    children: [{ text: '' }]
  }
  Transforms.insertNodes(editor, mention)
  Transforms.move(editor)
}

export const useMention = (editor) => {
  const [target, setTarget] = useState<any>()
  const [search, setSearch] = useState('')
  const [index, setIndex] = useState(0)
  const ref = useRef<any>()

  const chars = CHARACTERS.filter((c) => c.toLowerCase().startsWith(search.toLowerCase())).slice(0, 10)

  useEffect(() => {
    if (target && chars.length > 0) {
      const el = ref.current!
      const domRange = ReactEditor.toDOMRange(editor, target)
      const rect = domRange.getBoundingClientRect()
      // @ts-ignore
      el.style.top = `${rect.top + window.pageYOffset + 24}px`
      // @ts-ignore
      el.style.left = `${rect.left + window.pageXOffset}px`
    }
  }, [chars.length, editor, index, search, target])

  const onKeyDown = useCallback(
    (event) => {
      if (target) {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault()
            const prevIndex = index >= chars.length - 1 ? 0 : index + 1
            setIndex(prevIndex)
            break
          case 'ArrowUp':
            event.preventDefault()
            const nextIndex = index <= 0 ? chars.length - 1 : index - 1
            setIndex(nextIndex)
            break
          case 'Tab':
          case 'Enter':
            event.preventDefault()
            Transforms.select(editor, target)
            insertMention(editor, chars[index])
            setTarget(null)
            break
          case 'Escape':
            event.preventDefault()
            setTarget(null)
            break
        }
      }
    },
    [index, search, target]
  )

  const onChange = useCallback(() => {
    const { selection } = editor

    if (selection && Range.isCollapsed(selection)) {
      const [start] = Range.edges(selection)
      const wordBefore = Editor.before(editor, start, { unit: 'word' })
      const before = wordBefore && Editor.before(editor, wordBefore)
      const beforeRange = before && Editor.range(editor, before, start)
      const beforeText = beforeRange && Editor.string(editor, beforeRange)
      const beforeMatch = beforeText && beforeText.match(/^@(\w+)$/)
      const after = Editor.after(editor, start)
      const afterRange = Editor.range(editor, start, after)
      const afterText = Editor.string(editor, afterRange)
      const afterMatch = afterText.match(/^(\s|$)/)

      if (beforeMatch && afterMatch) {
        // @ts-ignore
        setTarget(beforeRange)
        setSearch(beforeMatch[1])
        setIndex(0)
      } else {
        setTarget(null)
      }
    }
  }, [editor])

  let ui: any = null
  if (target && chars.length > 0) {
    ui = (
      <Portal>
        <div
          ref={ref}
          style={{
            top: '-9999px',
            left: '-9999px',
            position: 'absolute',
            zIndex: 1,
            padding: '3px',
            background: 'white',
            borderRadius: '4px',
            boxShadow: '0 1px 5px rgba(0,0,0,.2)'
          }}
        >
          {chars.map((char, i) => (
            <div
              key={char}
              style={{
                padding: '1px 3px',
                borderRadius: '3px',
                background: i === index ? '#B4D5FF' : 'transparent'
              }}
            >
              {char}
            </div>
          ))}
        </div>
      </Portal>
    )
  }

  return { ui, onChange, onKeyDown }
}
